const Colors = {
  PrimaryColor: "#17082d",
  SecondaryColor: "#d42a34",
  TertiaryColor: "#bc4b54",
  ButtonColors: {
    "background-color": "#17082d",
    "border-color": "#17082d",
    color: "#fff",
  },
};

export default Colors;